import { API_ROOT_URL } from "../config";

export const authService = {
  login,
  logout,
  register,
  forgotPassword,
  newPassword,
  changePassword,
  getUserData,
  getOnBoardingStatus
};

function forgotPassword(email_address) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  };

  return fetch(`${API_ROOT_URL}/users/auth/password/reset/?email_address=${email_address}`, requestOptions).then(handleResponse => {
    return handleResponse;
  });
}

function newPassword(password1, password2, code) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password1, password2 })
  };

  return fetch(`${API_ROOT_URL}/users/auth/password/reset/confirm/?code=${code}`, requestOptions).then(handleResponse => {
    return handleResponse;
  });
}

function changePassword(old_password, new_password) {
  const token = JSON.parse(localStorage.getItem("token"));

  const requestOptions = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ new_password, old_password })
  };

  return fetch(`${API_ROOT_URL}/users/user/change_password/`, requestOptions).then(handleResponse => {
    return handleResponse;
  });
}

function login(email_address, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email_address, password })
  };

  return fetch(`${API_ROOT_URL}/administrator/login/`, requestOptions).then(handleResponse => {
    return handleResponse;
  });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.clear();
}

function register(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user)
  };

  return fetch(`${API_ROOT_URL}/users/create/`, requestOptions).then(handleResponse => {
    return handleResponse;
  });
}

function getUserData() {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: { Authorization: "Bearer " + token }
  };
  return fetch(`${API_ROOT_URL}/users/user/me/`, requestOptions).then(handleResponse => {
    return handleResponse.json();
  });
}

function getOnBoardingStatus(onboardingLoginEmail) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  };

  return fetch(`${API_ROOT_URL}/users/auth/check_email/?email=${onboardingLoginEmail}`, requestOptions).then(handleResponse => {
    return handleResponse;
  });
}



// WEBPACK FOOTER //
// ./src/services/auth.service.js